export default {"src":"/_next/static/media/core-logic.e2d11aef.svg","height":380,"width":2251,"blurWidth":0,"blurHeight":0};